import myInserts from '../hasura/myInserts';

// import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'


try{

}catch(e){

    
}


export default{

    sendError(apollo, userId = 0, viewName, componentName, methodName, statement){
        
        let error;

        if(JSON.stringify(statement) != '{}'){

            // console.log(` yes error != {} `);
            error = JSON.stringify(statement);
        }
        else{
            
            // console.log(` no error == {} `)

            error = statement.toString();
        }

        if(navigator.userAgent == 'Safari/602.1 ios-pnadi')
        {

            alert(`error: ${error}`)
        }

        if(this.getDevelopmentMode() == 'development'){

            console.log(`Error Statement ${error}`);
            
            console.log(`View    Name: ${viewName}, Component Name: ${componentName}, Method Name: ${methodName}, `);
            
            return;
        }
        if(error.includes('status code 503')){

            return;
        }

        try{

            apollo.mutate({

                mutation: myInserts.errors_logs_insert,
    
                variables: {
    
                    userId: userId,
                    componentName: componentName,
                    methodName: methodName,
                    viewName: viewName,
                    error: error,
                },
                    
                error(error){

                    if(JSON.stringify(error) != '{}'){

                        error = JSON.stringify(error);
                        console.log(`mutation error is json`);
                    }
                    
                    console.log(`mutationError is ${error}`);                    
                }
            });    

        }catch(e){

            if(JSON.stringify(e) != '{}'){

                e = JSON.stringify(e);
                console.log(`call error is json`);
            }
            
            console.log(`callError is ${e}`);
            
            // this.sendError(apollo, userId, 'ComponentHelpers', 'SendError', '', error.msg )
        }       
    },

    toastIt(toast, msg, option, theme, isTop){
        
        //theme: 'bubble, 'outline, 'toasted-primary'

        // console.log(`inside toastit`);
        let subOptions;
        
        if(isTop)
        {

            subOptions =  {  theme, position: "bottom-center", duration : 5000};

            // subOptions =  {  theme, position: "top-center", duration : 5000};
        }
        else{

            subOptions =  {  theme, position: "bottom-center", duration : 5000};
        }

        toast.clear();

        if(option == 1)
        {

            toast.info(msg, subOptions);
        }
        else if(option == 2){


            toast.success(msg, subOptions);

        }
        else{
            

            toast.error(msg, subOptions);
        }

    },

    appBanner(toast){
        
        const msg = "When you add our app to your homescreen, it will change to a mobile app";
        
        let subOptions;

            subOptions =  {theme: 'toasted-primary', position: "top-center", duration : 10000};

        // toast.clear();


            toast.info(msg, subOptions);
    },

    covidMsg(toast){
        
        const msg = "During this hard time and to comply with social distancing rule, only online classes are allowed for now";
        
        let subOptions;

            subOptions =  {theme: 'outline', position: "top-center", duration : 500000};

        toast.clear();

            toast.error(msg, subOptions);
    },

    RamadanOffer(toast){
        
        const msg = "To assist businesses and individuals now, the commission on classes will be Zero percent during Ramadan";
        let subOptions

            subOptions =  {theme: 'bubble', position: "bottom-center", duration : 500000};

        // toast.clear();


            toast.success(msg, subOptions);
    },

    isPinkStyle(){

        let myStyle;
        
        if(localStorage.hasOwnProperty('myStyle')){

            myStyle = localStorage.getItem('myStyle');

            if(myStyle == 'pink'){

                console.log(`helper isPinkStyle: true`);
                return true;
            }else{

                console.log(`helper isPinkStyle: false`);
                return false;
            }
        }
        else{
            
            console.log(`helper isPinkStyle: true`);
            return true;
        }
    },

    getDevelopmentMode(){

        // console.log(`getDevelopmentMode: ${process.env.VUE_APP_SERVER_MY_MODE}`);

        return process.env.VUE_APP_SERVER_MY_MODE;
    },

    getUserId(self){

        // console.log(`getDevelopmentMode: ${process.env.VUE_APP_SERVER_MY_MODE}`);

        return self.$userId;
    },

    informAdmin(title, msg){

        try{

            let result =  axios({method: 'post',url: '/pnadiapi/admin/notifyAdmin',
                
            data: {
                
                    title: title,
                    msg: msg,
                }
            });
            
        }catch(error){
            
            
        }
    },

    isIos(){

        // console.log(`in isIos`);
        return navigator.userAgent == 'Safari/602.1 ios-pnadi'
    },

    printValue(name, object){

        console.log(`${name}: ${object}`);
    },

    printJson(name, object){

        console.log(`${name}: ${JSON.stringify(object)}`);
    }
}